import React from 'react';
import { useTranslation } from 'react-i18next';
import Tip from '../Tip/Tip';
import styles from './sass/OrganizationTips.module.scss';

const TipOrganizationFunctionalDriver = () => {
  const { t } = useTranslation();
  return (
    <Tip
      styleTipTextContainer={styles.driverContainer}
      styleTriangle={styles.triangle}
    >
      <p>
        {t('tipOrganizationFunctionalDriver')}
      </p>
    </Tip>
  );
};

export default TipOrganizationFunctionalDriver;
